// Typelizer digest f6a74154456a2b1f7873d7e154504e5c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** GET /accountant/clients/:client_id/setup */
  show: (
    params: { clientId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/accountant/clients/:client_id/setup', params, options),
    method: 'get',
  }),
}
